import React from 'react';
import * as indexStyle from './index.module.scss';
import * as altStyle from './partnership.module.scss';

const Partnership = ({ label, children, alternate = false, projectPage = false, fellowshipPage = false, bgColor, usePadding }) => {
	if (alternate) {
		let extraStyle = '';
		if (projectPage) {
			extraStyle = `${altStyle.projectPage}`;
		}
		if (fellowshipPage) {
			extraStyle = `${altStyle.fellowshipPage}`;
		}

		return (
			<div className={`${altStyle.container} ${extraStyle}`}>
				<div className={altStyle.wrap}>
					<h4>IN PARTNERSHIP WITH</h4>
					<div className={altStyle.content}>
						{children}
					</div>
				</div>
			</div>
		);
	}

	const elStyle = {
		backgroundColor: bgColor || 'transparent',
		padding: usePadding ? '20px' : 0,
	};

	return (
		<div className={indexStyle.container} style={elStyle}>
			<div className={indexStyle.wrap}>
				{label && <h4>{label}</h4>}
				<div className={indexStyle.children}>
					{children}
				</div>
			</div>
		</div>
	);
};

export default Partnership;
